import { ProviderFeeType } from './mapToLutherMortgage.fixtures'

export const mapToLutherFeeType: { [key in ProviderFeeType]: MortgageProductFeeType } = {
  [ProviderFeeType.AdministrationFee]: 'ADMINISTRATION_FEE',
  [ProviderFeeType.ApplicationFee]: 'APPLICATION_FEE',
  [ProviderFeeType.ArrangementFee]: 'ARRANGEMENT_FEE',
  [ProviderFeeType.AssessmentFee]: 'ASSESSMENT_FEE',
  [ProviderFeeType.BookingFee]: 'BOOKING_FEE',
  [ProviderFeeType.BrokerFee]: 'BROKER_FEE',
  [ProviderFeeType.ChapsTelegraphicTransferFee]: 'CHAPS_TELEGRAPHIC_TRANSFER_FEE',
  [ProviderFeeType.CompletionFee]: 'COMPLETION_FEE',
  [ProviderFeeType.DeedsReleaseFee]: 'DEEDS_RELEASE_FEE',
  [ProviderFeeType.DisbursementFee]: 'LEGAL_FEE',
  [ProviderFeeType.EarlyRepaymentCharge]: 'EARLY_REPAYMENT_CHARGE',
  [ProviderFeeType.HigherLendingCharge]: 'HIGHER_LENDING_CHARGE',
  [ProviderFeeType.HomebuyersFee]: 'VALUATION_FEE',
  [ProviderFeeType.InsuranceAdministration]: 'INSURANCE_ADMINISTRATION',
  [ProviderFeeType.LandRegistryFee]: 'LAND_REGISTRY_FEE',
  [ProviderFeeType.LegalFee]: 'LEGAL_FEE',
  [ProviderFeeType.LenderConveyancingFee]: 'LENDER_CONVEYANCING_FEE',
  [ProviderFeeType.MasterBrokerFee]: 'MASTER_BROKER_FEE',
  [ProviderFeeType.MortgageAccountFee]: 'MORTGAGE_ACCOUNT_FEE',
  [ProviderFeeType.OtherFee]: 'OTHER_FEE',
  [ProviderFeeType.PackagerFee]: 'PACKAGER_FEE',
  [ProviderFeeType.ProductTransferFee]: 'PRODUCT_TRANSFER_FEE',
  [ProviderFeeType.ReInspectionFee]: 'RE_INSPECTION_FEE',
  [ProviderFeeType.RedemptionAdminFee]: 'REDEMPTION_ADMIN_FEE',
  [ProviderFeeType.TitleDeedsAdminFee]: 'TITLE_DEEDS_ADMIN_FEE',
  [ProviderFeeType.ValuationFee]: 'VALUATION_FEE',
}
